export default "__VITE_ASSET__7f92e857__"